// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__swSkq","options":"AnswerScale_options__89s8N","selected":"AnswerScale_selected__WtM52"};